<template>
	
	<div>
		
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
		<Hero :slides="hero.slides" :smallHero="hero.smallHero"></Hero>
		<Search :placeholderText="search.placeholderText" :icon="search.icon"></Search>
		

            <ul class="anchor-tabs">
                <li>
                    <a class="active" href="#latest-news">Latest News</a>
                </li>
                <li>
                    <a href="#fgtv">Fgtv</a>
                </li>
                <li>
                    <a href="#upcoming-events">upcoming events</a>
                </li>
                <li>
                    <a href="#press-releases">press releases</a>
                </li>
                <li>
                    <a href="#">awards & recognitions</a>
                </li>
            </ul>
            <div class="container">
                <div class="title-text">
                    <h3 class="title">
                        Page Title
                    </h3>
                    <div class="text">
                        The Fulton County Board of Commissioners includes seven members, with six district seats and the Chairman serving all of Fulton County, including 15 cities. The Board of Commissioners meet twice a month, on the first and third Wednesdays at 10 a.m. Meetings are live-streamed via FGTV and may be viewed on this website.
                    </div>
                </div>
            </div>

            <News :subtitle="latestNews.subtitle" :title="latestNews.title" :fullWidthNewsItems="latestNews.fullWidthNewsItems" :halfWidthNewsItems="latestNews.halfWidthNewsItems" :miniNewsItems="latestNews.miniNewsItems" :cta="latestNews.cta"></News>
            <News :subtitle="fgtv.subtitle" :title="fgtv.title" :fullWidthNewsItems="fgtv.fullWidthNewsItems" :halfWidthNewsItems="fgtv.halfWidthNewsItems" :miniNewsItems="fgtv.miniNewsItems" :cta="fgtv.cta"></News>
            <UpcomingEvents :subtitle="upcomingEvents.subtitle" :title="upcomingEvents.title" :featuredEvents="upcomingEvents.featuredEvents" :miniEvents="upcomingEvents.miniEvents" :cta="upcomingEvents.cta"></UpcomingEvents>
            <News :subtitle="pressRelease.subtitle" :title="pressRelease.title" :fullWidthNewsItems="pressRelease.fullWidthNewsItems" :halfWidthNewsItems="pressRelease.halfWidthNewsItems" :miniNewsItems="pressRelease.miniNewsItems" :cta="pressRelease.cta"></News>

            <div id="media-contacts" class="contact-list-group container-fluid">

                <TitleHeader :subtitle="contactCards.subtitle" :title="contactCards.title"></TitleHeader>

                <div class="container">
                    <div class="row">
                        <div class="col-lg-4" :key="card.id" v-for="card in cards">
                            <ContactCard :contactCard="card"></ContactCard>
                        </div>
                    </div>
                </div>
                <PrimaryButton class="center" v-if="contactCards.cta" :linkText="contactCards.cta.linkText" :linkURL="contactCards.cta.linkURL"></PrimaryButton>
            </div>
            <div class="static-link-list">

                <TitleHeader :subtitle="'more'" :title="'helpful links'"></TitleHeader>

                <div class="container">
                    <!--Currently each accordion within an accordion group will close automatically if another is clicked.
            If this functionality is not needed a class of keep-open can be added to a accordion-container to prevent this-->
                    <div class="row accordion-group">
                        <div class="accordion-container link-list col-lg-12">
                            <button class="accordion-trigger" type="button">
                                <h3 class="title">
                                    doing business with fulton county
                                </h3>
                                <div class="icon">
                                    <i></i>
                                    <i></i>
                                </div>
                            </button>
                            <div class="accordion">
                                <ul>
                                    <li>
                                        <a href="#">how do I do this?</a>
                                    </li>
                                    <li>
                                        <a href="#">how do I do that?</a>
                                    </li>
                                    <li>
                                        <a href="#">how do I do that other thing?</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="accordion-container link-list col-lg-12">
                            <button class="accordion-trigger" type="button">
                                <h3 class="title">
                                    corporations
                                </h3>
                                <div class="icon">
                                    <i></i>
                                    <i></i>
                                </div>
                            </button>
                            <div class="accordion">
                                <ul>
                                    <li>
                                        <a href="#">how do I do this?</a>
                                    </li>
                                    <li>
                                        <a href="#">how do I do that?</a>
                                    </li>
                                    <li>
                                        <a href="#">how do I do that other thing?</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="accordion-container link-list col-lg-12">
                            <button class="accordion-trigger" type="button">
                                <h3 class="title">
                                    bidding on projects
                                </h3>
                                <div class="icon">
                                    <i></i>
                                    <i></i>
                                </div>
                            </button>
                            <div class="accordion">
                                <ul>
                                    <li>
                                        <a href="#">how do I do this?</a>
                                    </li>
                                    <li>
                                        <a href="#">how do I do that?</a>
                                    </li>
                                    <li>
                                        <a href="#">how do I do that other thing?</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <NewsletterSignup :subtitle="newsletterSignup.subtitle" :title="newsletterSignup.title" :body="newsletterSignup.body" :submit="newsletterSignup.submit" :forms="newsletterSignup.forms"></NewsletterSignup>
            <Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>
	</div>
	
	
</template>

<script>

	import Header from '../components/Header/Header.vue';
	import Hero from '../components/Hero/Hero.vue';
	import Search from '../components/Search/Search.vue';
	import TitleHeader from '../components/Global/TitleHeader.vue';
    import PrimaryButton from '../components/Global/PrimaryButton.vue';
    import UpcomingEvents from '../components/Events/UpcomingEvents.vue';
	import ContactCard from '../components/ContactCard/ContactCard.vue';
    import NewsletterSignup from '../components/News/NewsletterSignup.vue';
    import News from '../components/News/News.vue';
	import Footer from '../components/Footer/Footer.vue';
    import axios from 'axios';

	export default {
		name: 'NewsroomLandingPage',
		
		components: {
			Header,
			Hero,
			Search,
			TitleHeader,
            PrimaryButton,
            News,
            UpcomingEvents,
			ContactCard,
			NewsletterSignup,
			Footer
		},
		
		data() {
			return {
                newsItems: [],
                latestNews: [],
                fgtv: {},
                videoItems: [],
                upcomingEvents: {},
                events: [],
                pressRelease: {},
                releases: [],
                contactCards: {},
				cards: [],
				
				header: {
					utilityNav: {},
					siteNavigation: {}
				},
				hero: {
					slides: [],
					smallHero: {}
				},
				search: {
					placeholderText: "",
					icon: ""
				},
				newsletterSignup: {
					subtitle: "",
					title: "",
					body: "",
					submit: "",
					forms: []
				},
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
			
			let header = 'SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let hero = 'SampleData/HeroData.json';
			axios.get(hero).then(function(response) {
				
				self.hero.slides = response.data.slides;
				self.hero.smallHero = response.data.smallHero;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let search = 'SampleData/SearchData.json';
			axios.get(search).then(function(response) {
				
				self.search.placeholderText = response.data.placeholderText;
				self.search.icon = response.data.icon;
			})
			.catch(function (error) {
				console.log(error);
			});
			
            let endpointID = this.$el.parentElement.getAttribute('data-endpoint-id');
            if (endpointID) {

                let endpoint = 'SampleData/' + endpointID + '.json';

                axios.get(endpoint).then(function (response) {
                    self.newsItems = response.data.latestNews.newsItems;
                    self.latestNews = response.data.latestNews;
                    self.fgtv = response.data.fgtv;
                    self.videoItems = response.data.fgtv.newsItems;
                    self.upcomingEvents = response.data.upcomingEvents;
                    self.events = response.data.upcomingEvents.events;
                    self.pressRelease = response.data.pressRelease;
                    self.releases = response.data.pressRelease.releases;
                    self.contactCards = response.data.contactCards;
                    self.cards = response.data.contactCards.cards;
                })
				.catch(function (error) {
					console.log(error);
				});
			}
			
			let newsletterSignup = 'SampleData/NewsletterSignupData.json';
			axios.get(newsletterSignup).then(function(response) {
				
				self.newsletterSignup.title = response.data.title;
				self.newsletterSignup.subtitle = response.data.subtitle;
				self.newsletterSignup.title = response.data.title;
				self.newsletterSignup.body = response.data.body;
				self.newsletterSignup.submit = response.data.submit;
				self.newsletterSignup.forms = response.data.forms;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let footer = 'SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>